import React from 'react';
import styles from './styles.scss';

const EssayInstructions = () => {
  return (
    <div className={styles.layout}>
      <div className={styles.layoutInner}>
        <div className={styles.instructions}>
          The timer will count down to the allotted time as a guide, but you will be
          allowed to finish even if it takes longer. Your essay is autosaved to our
          servers every minute. Once you submit your essay it will be graded by our AI/ML
          algorithms and you&apos;ll get a score immediately.
        </div>
        <div className={styles.copyright}>
          All rights reserved &copy;2016 - {new Date().getFullYear()} Achievable, Inc.
        </div>
      </div>
    </div>
  );
};

export default EssayInstructions;
